module.exports = [
  require('./and'),
  require('./not'),
  require('./or'),
  require('./xor')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/logical/index.js
// module id = 1210
// module chunks = 0